import React from 'react'

import CompanyLogoOrName from '@/components/misc/CompanyLogoOrName'
import ReferralESignatureConsentPdf from '@/components/misc/ReferralESignatureConsentPdf/ReferralESignatureConsentPdf'
import { cn } from '@/lib/utils'

interface Props {
  company: React.ComponentProps<
    typeof ReferralESignatureConsentPdf
  >['referral']['fromCompany']
  className?: string
}

const FromCompanyLogoOrName: React.FC<Props> = ({ company, className }) => (
  <CompanyLogoOrName
    name={company.presentationName}
    truncateName={false}
    wrapperProps={{
      className: cn('font-medium text-black', className),
      style: { fontSize: '28px', lineHeight: '1.5' },
    }}
    showLogoFallback={false}
    logoUrl={company.logoUrl}
    imageStyle={{ maxHeight: '85px', maxWidth: '240px' }}
  />
)

export default FromCompanyLogoOrName
